import { useUserContext } from "@/components/user-context";

import { LoggedInLoom } from "./logged-in";
import { LoggedOutLoom } from "./logged-out";

export const LoomSignup = ({
    shouldForceOverlayView
}: {
    shouldForceOverlayView?: boolean;
} = {}) => {
    const {
        user: { isUserLoggedIn }
    } = useUserContext();

    if (isUserLoggedIn) {
        return <LoggedInLoom shouldForceOverlayView={shouldForceOverlayView} />;
    }

    return <LoggedOutLoom shouldForceOverlayView={shouldForceOverlayView} />;
};
